import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";

// Old SCSS (will be removed after full migration)
// import "./assets/style.scss";

// New Tailwind CSS
import "./index.css";
import { store, persistor } from "./redux/store";
import App from "./App";
import OverlayLoader from "./components/Loader/OverlayLoader";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={<OverlayLoader />} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
